<template>
<!--  @touchmove.prevent-->
  <div id="preview-view">
    <mt-popup v-model="show" :closeOnClickModal="0" class="preview-popup">
      <div class="content">
        <div class="title">长按保存图片</div>
        <div class="image">
          <img :src="imgUrl">
        </div>
        <div class="close" @click="closePreviewClick"></div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  props: {
    show: false,
    imgUrl: ''
  },
  data () {
    return {
    }
  },
  methods: {
    closePreviewClick: function () {
      // 取消
      this.$emit('previewClick')
    }
  }
}
</script>

<style scoped>
  .preview-popup{
    position: center;
    width: 90%;
    height: calc(100% - 180px);
    border-radius: 3px;
  }
  .preview-popup .content{
    position: relative;
    margin: 20px 0px 0px 0px;
    height: 100%;
    width: 100%;
    /*background-color: yellow;*/
  }
  .content .title{
    position: absolute;
    left: 0px;
    right: 0px;
    width: 100%;
    top: -40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight:bold;
    color: #FFFFFF;
    font-size: 18px;
    background-color: #c41335;
  }
  .content .close{
    position: absolute;
    bottom: -45px;
    left:50%;
    transform:translate(-50%,0);
    -webkit-transform:translate(-50%,0);
    width: 30px;
    height: 30px;
    background-image: url(../assets/delete.png);
    background-size: cover;
    background-position: center center;
  }
  .content .image{
    /*position: absolute;*/
    /*top: 0px;*/
    /*left: 0px;*/
    /*right: 0px;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*overflow: auto;*/
    /*text-align: center;*/
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    overflow: auto;
    text-align: center;
    /*width: 95%;*/
  }
  .content .image img{
    position: relative;
    /*width: auto;*/
    /*max-width: 100%;*/
    width: 100%;
    height: auto;
    /*width: 100%;*/
    /*height: 100%;*/
  }

</style>



// WEBPACK FOOTER //
// src/components/preview-image.vue